import { Sparkle } from 'lucide-react';
import { Reveal } from './Reveal';

const VALUES = ['Detail-Focused', 'Fresh & Professional', 'Clear Communication'];

export const TrustStrip = () => (
  <section aria-label="Why families choose KINDSTONE" className="ks-trust border-b border-white/10">
    <div className="mx-auto max-w-7xl px-4 py-9 sm:px-6 lg:px-8">
      <Reveal>
        <ul className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-0">
          {VALUES.map((v, i) => (
            <li key={v} className="flex items-center">
              <span className="text-base font-bold tracking-wide text-white sm:text-lg">{v}</span>
              {i < VALUES.length - 1 && (
                <Sparkle
                  size={14}
                  className="mx-6 hidden text-aqua sm:block"
                  aria-hidden="true"
                />
              )}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export default TrustStrip;
